import { Page } from "powerbi-client";

// src/app/analytics/events.ts
export const EVENTS = {
  USER_SIGNED_UP: 'UserSignedUp',
  USER_ROLE_ACTION: 'UserRoleAction',
  USER_LOGGED_IN: 'UserLoggedIn',
  MAPTILER_LOADED: 'MapTilerLoaded',
  USER_LOGGED_OUT: 'UserLoggedOut',
  HARD_PAGE_REFRESH: 'HardPageRefresh',
  PAGE_VIEWED: 'PageViewed',
  USER_ACTIVITY: 'UserActivity',
  DEVICE_INFO_CAPTURED: 'DeviceInfoCaptured',
  SESSION_STARTED: 'SessionStarted',
  SESSION_ENDED: 'SessionEnded',
  FEATURE_USED: 'FeatureUsed',
  ERROR_OCCURRED: 'ErrorOccurred',
  ALERT_INTERACTED: 'AlertInteracted',
  API_CALLED: 'ApiCalled',
  TIME_SINCE_LAST_SESSION: 'TimeSinceLastSession',
  CONVERSION_OCCURRED: 'ConversionOccurred',
  FILTER_APPLIED: 'FilterApplied',
  APP_CRASHED: 'AppCrashed',
  PAGE_LOAD_SLOW: 'PageLoadSlow',
  VESSEL_SELECTED: 'VesselSelected',
  //MAPTILER_Sections
  MAPTILER_VESSEL_SEARCH: 'MapTilerVesselSearch',
  MAPTILER_SEARCH_SELECTED_VESSEL: 'MapTilerSearchSelectedVessel',
  //TimeCharterer_Sections
  TIMECHARTERER_VESSEL_SEARCH: 'TimeChartererVesselSearch',
  TIMECHARTERER_SEARCH_SELECTED_VESSEL: 'TimeChartererSearchSelectedVessel',
  TIMECHARTERER_REPORT_GENERATED: 'TimeChartererReportGenerated',

  //EU_MRV
  EU_MRV_REPORT_GENERATED: 'EU_MRV_ReportGenerated',

  EMS_IMO_DCS_REPORT_GENERATED: 'EMS_IMO_DCS_ReportGenerated',
  EMS_IMO_DCS_SCHEDULED_REPORT_GENERATED: 'EMS_IMO_DCS_ScheduledReportGenerated',

  VERIFICATION_REPORT_GENERATED: 'VerificationReportGenerated',
  VERIFICATION_SCHEDULED_REPORT_GENERATED: 'VerificationScheduledReportGenerated',

  //Penalty Calculator Events
  ESTIMATED_EXPOSURE_FUEL_EU: 'EstimatedExposureFuelEU',
  FUEL_EU_REPORT_GENERATED: 'FuelEUReportGenerated',
  FUEL_EU_SCHEDULED_REPORT_GENERATED: 'FuelEUScheduledReportGenerated',
  FUEL_EU_OPERATOR_DATA_LOADED: 'FuelEUOperatorDataLoaded',

  //Report Page Events
  HCR_REPORT_GENERATED: 'HCRReportGenerated',
  BUNKER_REPORT_GENERATED: 'BunkerReportGenerated',
  POOL_PERFORMANCE_REPORT_GENERATED: 'PoolPerformanceReportGenerated',
  DIGITAL_TWIN_REPORT_GENERATED: 'DigitalTwinReportGenerated',
  EMISSION_REPORT_GENERATED: 'EmissionReportGenerated',
  PASSAGE_PERFORMANCE_DETAIL_REPORT_GENERATED: 'PassagePerformanceDetailReportGenerated',
  EVENT_REPORT_GENERATED: 'EventReportGenerated',
  VESSEL_DAILY_REPORT_GENERATED: 'VesselDailyReportGenerated',
  TECHNICAL_PERFORMANCE_REPORT_GENERATED: 'TechnicalPerformanceReportGenerated',
  POOL_RECAP_PERFORMANCE_REPORT_GENERATED: 'PoolRecapPerformanceReportGenerated',
  EOV_REPORT_GENERATED: 'EOVReportGenerated',
  VOYAGE_TC_PERFORMANCE_REPORT_GENERATED: 'VoyageTCPerformanceReportGenerated',
  VESSEL_DAILY_DETAIL_REPORT_GENERATED: 'VesselDailyDetailReportGenerated',
  EU_ETS_FLEET_REPORT_GENERATED: 'EUETSFleetReportGenerated',
  LNG_VOYAGE_TC_PERFORMANCE_REPORT_GENERATED: 'LNGVoyageTCPerformanceReportGenerated',

  DOWNLOAD_REPORT: 'DownloadReport',
};
